import { Dialog } from "@reach/dialog";
import "@reach/dialog/styles.css";
import { VisuallyHidden } from "@reach/visually-hidden";
import classNames from "classnames";
import Clickable from "components/Clickable";
import { BaseDialogProps } from "components/Favorites/interfaces";

import CloseIcon from "../../public/svg/x.svg";

import styles from "./modal.module.scss";

export interface BaseModalProps extends BaseDialogProps {
    /** We use a 12-column layout for designs; these correspond to 12, 8, and 6 columns */
    width?: "full" | "twoThirds" | "half";
    /**
     * We use a 12-column layout for designs; "column" uses one column for padding-left
     * and one for padding-right
     */
    padding?: "column" | "minimal";
}

interface Props extends BaseModalProps {
    children: React.ReactNode;
    /** An ARIA thing. This value must match an ID for a heading inside of a modal. */
    labelId: string;
}

export const Modal = ({
    isOpen,
    close,
    children,
    labelId,
    width = "half",
    padding = "column",
}: Props) => (
    <Dialog
        className={styles.modal}
        aria-labelledby={labelId}
        isOpen={isOpen}
        onDismiss={close}
    >
        <div
            className={classNames([styles[width], styles[`${padding}Padding`]])}
        >
            <Clickable unstyled={true} onClick={close} className={styles.close}>
                <CloseIcon />
                <VisuallyHidden>Close Modal</VisuallyHidden>
            </Clickable>
            <div>{children}</div>
        </div>
    </Dialog>
);
